import { NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AaNgModule } from 'aa-ng';
import { QuicklinkDirective } from 'ngx-quicklink';
import { IPerson } from 'src/app/models';

import { PersonUrlPipe } from '../../pipes/person-url.pipe';

@Component({
  selector: 'app-similar-scholars',
  imports: [AaNgModule, NgStyle, PersonUrlPipe, QuicklinkDirective, RouterLink],
  templateUrl: './similar-scholars.component.html',
  styleUrls: ['./similar-scholars.component.scss'],
})
export class SimilarScholarComponent {
  ulStyles: { [key: string]: string | number } = {};
  _useH3forTitle = false;

  @Input() similarScholars: IPerson[];

  @Input() set showBulletedList(showBullets: boolean) {
    this.ulStyles['list-style-type'] = showBullets ? 'disc' : 'none';
  }

  @Input() set padding(pixelValue: number) {
    this.ulStyles['padding'] = pixelValue;
  }

  @Input() set columns(columns: number) {
    this.ulStyles['columns'] = columns;
  }

  @Input() set useH3forTitle(useH3: boolean) {
    this._useH3forTitle = useH3;
  }
}
